export { default as ErrorModal } from './ErrorModal/ErrorModal';
export { default as SuccessModal } from './SuccessModal/SuccessModal';
export { default as ConsentModal } from './ConsentModal/ConsentModal';

export { showSuccessSendModal, showErrorSendModal, showModal } from './utils';
